export default __webpack_public_path__ + "static/media/chevron-up-circle.88eaa973.svg";